(function() {
  if (window.__sunthebrand_chat_loaded) return;
  window.__sunthebrand_chat_loaded = true;

  const lang = (navigator.language || 'es').toLowerCase().substring(0, 2);
  const helpLabels = { es: '¿Ayuda?', en: 'Help?', fr: 'Aide ?', pt: 'Ajuda?', it: 'Aiuto?' };
  const helpText = helpLabels[lang] || helpLabels.es;

  const btn = document.createElement('button');
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>';
  btn.style.cssText = 'position:fixed;bottom:24px;right:24px;width:60px;height:60px;border-radius:50%;background:#1a1a1a;color:white;border:none;cursor:pointer;z-index:9999;box-shadow:0 4px 16px rgba(0,0,0,0.35);transition:all 0.3s ease;display:flex;align-items:center;justify-content:center;font-family:system-ui,-apple-system,sans-serif;';
  btn.onmouseover = () => { btn.style.transform = 'scale(1.1)'; btn.style.boxShadow = '0 6px 20px rgba(0,0,0,0.45)'; };
  btn.onmouseout = () => { btn.style.transform = 'scale(1)'; btn.style.boxShadow = '0 4px 16px rgba(0,0,0,0.35)'; };
  btn.title = helpText;

  // Etiqueta de ayuda (solo desktop)
  const isMobile = window.innerWidth < 768;
  const label = document.createElement('span');
  label.innerText = helpText;
  label.style.cssText = 'position:fixed;bottom:36px;right:92px;background:#1a1a1a;color:white;padding:6px 12px;border-radius:20px;font-size:13px;font-family:system-ui,-apple-system,sans-serif;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,0.2);z-index:9999;transition:opacity 0.3s ease;pointer-events:none;display:' + (isMobile ? 'none' : 'block') + ';';

  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;bottom:100px;right:24px;width:400px;height:500px;max-width:90vw;max-height:80vh;border:none;border-radius:12px;box-shadow:0 5px 40px rgba(0,0,0,0.16);z-index:9998;display:none;background:#fff;';
  iframe.allow = 'geolocation; microphone; camera';
  iframe.title = 'Chat de soporte SunTheBrand';

  setTimeout(() => { iframe.src = 'https://logical-sun-care-flow.base44.app/chat-widget'; }, 2000);

  let isOpen = false;
  btn.onclick = (e) => {
    e.preventDefault();
    isOpen = !isOpen;
    if (!iframe.src || iframe.src === 'about:blank') {
      iframe.src = 'https://logical-sun-care-flow.base44.app/chat-widget';
    }
    iframe.style.display = isOpen ? 'block' : 'none';
    btn.innerHTML = isOpen
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>';
    if (!isMobile) label.style.opacity = isOpen ? '0' : '1';
  };

  document.body.appendChild(label);
  document.body.appendChild(btn);
  document.body.appendChild(iframe);
})();